module.exports = __webpack_public_path__ + "assets/img/2-2.14f62c74.png";